import React from 'react';
import StyledBox from 'views/rebranded-module/common/components/Logical/LayoutV2/FooterV2/FooterV2.styles';
import {
  FooterSubscribe,
  FooterLinks,
} from 'views/rebranded-module/common/components/Logical/LayoutV2/FooterV2';
import { Container, Box } from '@mui/material';
import { ImgBox } from 'views/common/components';

const FooterV2 = () => (
  <StyledBox component="footer">
    <Box className="FBGImage">
      <ImgBox
        className="showDESKTOP"
        image={{
          src: '/imgs/Rebranding/Layout/footer-background-LG.jpg',
          alt: 'footer-background',
        }}
        imgHeight="100%"
        imgWidth="100%"
        imgObjectFit="cover"
        priority
      />
      <ImgBox
        className="showTABLET"
        image={{
          src: '/imgs/Rebranding/Layout/footer-background-SM.jpg',
          alt: 'footer-background',
        }}
        imgHeight="100%"
        imgWidth="100%"
        imgObjectFit="cover"
      />
    </Box>
    <Container maxWidth="xl" className="FContainer">
      <FooterSubscribe />
      <FooterLinks />
    </Container>
  </StyledBox>
);

export { FooterV2 };
